import { PropsWithChildren } from 'react';
import Action from './Action';

const Actions = ({ children }: PropsWithChildren) => {
	return <div className="flex gap-1">{children}</div>;
};

Actions.Action = Action;

export default Actions;
